Object.defineProperty(exports, '__esModule', {
  value: true
})

// Customizable Area Start
exports.httpGetMethod = 'GET';
exports.advancedsearchApiContentType = 'application/json';
exports.getAdvancedSearchApiEndPoint = 'advanced_search/search';
exports.errorTitle = 'Error';
// Customizable Area End
